export default __webpack_public_path__ + "static/media/nodatasmall.b6f9bd44.png";